import React from 'react';
import Section from 'components/Section';
import Map from 'components/common/Map';
import ListingCarousel from 'components/ListingCarousel';
import { pluralize } from 'utils';

export default ({ id, title, description, listings, listingsCount, markers }) => (
  <Section name={id} title={title} description={description} isFull={true}>
    <div className="container text-center mt-6 px-4 px-sm-3">
      <h3>{listingsCount} {pluralize('way', listingsCount)} to relax</h3>
      { listings && <ListingCarousel listings={listings} /> }
    </div>
    <div className="mt-55 home-map-container container">
      <Map markers={markers}/>
    </div>
  </Section>
);


// WEBPACK FOOTER //
// ./src/components/About.js